/** @format */
import localStorage from "local-storage";
import PersonIcon from "@mui/icons-material/Person";
import { Button, Grid, Tooltip, Typography } from "@mui/material";
import { lighten } from "polished";
const cellStyle = (params) => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    whiteSpace: "nowrap", // Metnin taşmasını önler
    textOverflow: "ellipsis", // Taşan metin için ...
  };
};
const createColumnDefs = (openModal) => {
  return [
    {
      field: "id",
      headerName: "",
      maxWidth: 180,
      suppressMenu: true,

      filter: false,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
        flexGrow: 1, // Hücrenin genişlemesini sağlar
      },
      cellRenderer: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => openModal(params.data.id)}
          sx={{ textTransform: "none", whiteSpace: "nowrap" }}
        >
          Kart ve Fişler
        </Button>
      ),
    },
    {
      field: "master",
      headerName: "",
      cellRenderer: "agGroupCellRenderer",
      editable: false,
      filter: false,
      maxWidth: 50,
    },
    {
      field: "vkn",
      headerName: "VKN",
      width: "10%",
      minWidth: 100,
      filter: "agTextColumnFilter", // Doğru kullanım

      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
      cellRenderer: (params) => (
        <Tooltip
          title={
            params.data?.vkn?.length === 10
              ? ""
              : "Vergi Kimlik No formatı yanlış lütfen düzeltin"
          }
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "700",
              color: params.data?.vkn?.length === 10 ? "" : "red",
              backgroundColor:
                params.data?.vkn?.length === 10 ? "" : lighten(0.4, "red"),
            }}
          >
            {params.data.vkn}{" "}
          </Typography>
        </Tooltip>
      ),
    },

    {
      field: "tckn",
      headerName: "TCKN",
      hide: true,
      width: "10%",
      minWidth: 110,
      filter: "agTextColumnFilter", // Doğru kullanım
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
      cellRenderer: (params) => (
        <Tooltip
          title={
            params.data?.tckn?.length === 11
              ? ""
              : "Tc Kimlik No formatı yanlış lütfen düzeltin"
          }
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "700",
              color: params.data.tckn?.length === 11 ? "" : "red",
              backgroundColor:
                params.data.tckn?.length === 11 ? "" : lighten(0.4, "red"),
            }}
          >
            {params.data.tckn}{" "}
          </Typography>
        </Tooltip>
      ),
    },

    {
      field: "title",
      filter: "agTextColumnFilter", // Doğru kullanım

      headerName: "Ünvan",
      width: 230,
      maxWidth: 250,

      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
    },
    {
      field: "ledgerType",
      filter: true, // Doğru kullanım

      headerName: "Defter Tipi",
      width: 130,
      maxWidth: 200,
      cellStyle: {
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
    },
    {
      field: "mobilePhone",
      filter: "agTextColumnFilter", // Doğru kullanım
      headerName: "Cep Tel ",
      width: "10%",
      minWidth: 120,
      hide: true,

      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
      cellRenderer: (params) => (
        <Grid
          item
          sx={{
            flexDirection: "row",
            display: "flex",
            overflow: "hidden",
            gap: 0.3,
          }}
        >
          {params.data.mobilePhone.map((item, index) => (
            <Tooltip
              key={index}
              title={
                item.startsWith("5")
                  ? ""
                  : "Telefon numarası formatı yanlış lütfen düzeltin"
              }
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  color: item.startsWith("5") ? "" : "red",
                  backgroundColor: item.startsWith("5")
                    ? ""
                    : lighten(0.4, "red"),
                }}
              >
                {item} {index === params.data.mobilePhone.length - 1 ? "" : ","}
              </Typography>
            </Tooltip>
          ))}
        </Grid>
      ),
    },
    {
      field: "email",
      headerName: "E-posta",
      width: "15%",
      filter: "agTextColumnFilter", // Doğru kullanım
      hide: true,
      minWidth: 95,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
      },
      suppressMenu: true,
    },

    {
      field: "workPhone",
      headerName: "iş Tel",
      filter: "agTextColumnFilter", // Doğru kullanım
      width: "20%", // Yüzdelik olarak genişlik belirlenebilir
      hide: true,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
        flexGrow: 1, // Hücrenin genişlemesini sağlar
      },
      suppressMenu: true,
    },
    {
      field: "workPhone",
      headerName: "iş Tel",
      filter: "agTextColumnFilter", // Doğru kullanım
      width: "20%", // Yüzdelik olarak genişlik belirlenebilir
      hide: true,
      cellStyle: {
        textAlign: "start",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
        flexGrow: 1, // Hücrenin genişlemesini sağlar
      },
      suppressMenu: true,
    },
    {
      field: "totalExpense",
      headerName: "Harcama Toplamı",
      filter: "agTextColumnFilter",
      cellStyle: cellStyle,
      suppressMenu: true,
      valueFormatter: (params) => {
        if (!params.value) return "0.00";
        const value = Number(params.value);
        const [integer, decimal] = value.toString().split(".");
        if (!decimal) return integer + ".00";
        return integer + "." + decimal.padEnd(2, "0").slice(0, 2);
      },
    },
    {
      field: "totalCollection",
      headerName: "Alınan Toplamı",
      filter: "agTextColumnFilter",
      cellStyle: cellStyle,
      suppressMenu: true,
      valueFormatter: (params) => {
        if (!params.value) return "0.00";
        const value = Number(params.value);
        const [integer, decimal] = value.toString().split(".");
        if (!decimal) return integer + ".00";
        return integer + "." + decimal.padEnd(2, "0").slice(0, 2);
      },
    },
    {
      field: "totalAccrual",
      headerName: "Borç Toplamı",
      filter: "agTextColumnFilter",
      cellStyle: cellStyle,
      suppressMenu: true,
      valueFormatter: (params) => {
        if (!params.value) return "0.00";
        const value = Number(params.value);
        const [integer, decimal] = value.toString().split(".");
        if (!decimal) return integer + ".00";
        return integer + "." + decimal.padEnd(2, "0").slice(0, 2);
      },
    },
    {
      headerName: "Mükellef Bakiyesi",
      field: "balance", // field şart değil, ama filtre vs. için gerekebilir
      valueGetter: (params) => {
        const accrual = params.data.totalAccrual || 0;
        const collection = params.data.totalCollection || 0;
        return accrual - collection;
      },
      filter: "agNumberColumnFilter",
      cellStyle: cellStyle,
      suppressMenu: true,
      valueFormatter: (params) => {
        if (!params.value) return "0.00";
        const value = Number(params.value);
        const [integer, decimal] = value.toString().split(".");
        if (!decimal) return integer + ".00";
        return integer + "." + decimal.padEnd(2, "0").slice(0, 2);
      },
    },
    {
      headerName: "Durum",
      field: "is_deleted",
      flex: 0,
      maxWidth: 100,
      cellRenderer: (params) => {
        // Gelen veriye göre renk ve metin belirle
        let buttonText = "";
        if (params.data.is_deleted === false) {
          buttonText = "Aktif";
        } else {
          buttonText = "Pasif";
        }

        // Buton oluştur
        return (
          <button
            sx={{
              textTransform: "none",
              mb: "3%",
              width: "50px",
            }}
            style={{
              backgroundColor:
                buttonText === "Aktif"
                  ? lighten(0.4, "#5cb85c")
                  : lighten(0.3, "#f0ad4e"),
              color: buttonText === "Aktif" ? "#12450f" : "#b3545c",
              padding: "6px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              width: "auto", // Tüm butonların genişliği (örneğin 200 piksel)
              "&:hover": {
                backgroundColor: "#1565c0", // Hover rengi
              },
            }}
          >
            {buttonText}
          </button>
        );
      },

      filterParams: {
        valueFormatter: function (params) {
          if (params.value === false) {
            return "Aktif";
          } else if (params.value === true) {
            return "Pasif";
          }
        },
      },
    },
  ];
};
export default createColumnDefs;
